<template>
  <div class="chartDom" ref="chartDom"></div>
</template>
<script>
import { color } from 'echarts'

export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      msg: '饼图-半径模式',
      echartParams: this.data,
      timeId: null,
      myChart: null
    }
  },
  created() {},
  mounted() {
    this.drawLineCustom(this.echartParams)
  },
  destroyed() {
    clearInterval(this.timeId)
  },
  methods: {
    drawLineCustom(params) {
      this.myChart = this.$echarts.init(this.$refs.chartDom)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: 10,
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: params.xdata,
            axisTick: { show: false },
            axisLine: {
                lineStyle: {
                    color: '#A4BEE266'
                }
            },
            axisLabel: {
                color: '#3B4F6A',
                fontFamily: 'DingTalk'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
                lineStyle: {
                    type: 'dashed',
                    color: '#A4BEE266'
                }
            },
            axisLabel: {
                color: '#3B4F6A',
                fontFamily: 'DingTalk'
            },
            minInterval: 1, // Y 轴的最小间隔为 1
          }
        ],
        series: [
          {
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
                color: 'rgba(255, 255, 255, 0.3)'
            },
            barWidth: 20,
            itemStyle: {
                borderRadius: [5, 5, 0, 0],
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#43BAE6' },
                { offset: 1, color: '#80DCBC' }
              ])
            },
            data: params.ydata
          }
        ]
      }

      this.myChart.setOption(option, true)
      window.addEventListener('resize', () => {
        if (this.myChart) {
          this.myChart.resize()
        }
      })
    }
  },

  watch: {
    data: {
      immediate: true,
      deep: true,
      handler: function(newValue, oldValue) {
        
        this.$nextTick(() => {
          clearInterval(this.timeId)
          this.drawLineCustom(newValue)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.chartDom {
  width: 100%;
  height: calc(100% - 30px);
}
</style>
